
const telemetryReplacementSelectOptions = [
    {label : 'Remove and re-submit', value : 'REMOVE_RESUBMIT'},
    {label : 'Replace LID', value : 'REPLACE_LID'}
];


export {telemetryReplacementSelectOptions};